/**
 * O que a tela de Prazos (`C-15`, ADR-068) usa e o teste confere, fora do componente — a
 * recarga a quente do Vite só funciona em arquivo que exporta só componente.
 */
import type { TrilhaDePrazoNaTela } from "../api/tipos";

/** A duração de cada trilha, como a régua da SENATRAN a escreve. */
export const DURACAO_DA_TRILHA: Record<TrilhaDePrazoNaTela["tipo"], string> = {
  ENVIO_24H: "24 h",
  PROCESSAMENTO_7D: "7 dias",
  AUTUACAO_30D: "30 dias",
  CNH_8D: "8 dias",
  CNH_15D: "15 dias",
  PAGAMENTO_CONTRATUAL: "contrato",
  ENVIO_AO_AUTUADOR: "autuador",
};

/** As abas da fila de urgência: as três trilhas, ou todas. */
export const ABAS_DA_FILA: {
  rotulo: string;
  trilha: "ENVIO_24H" | "PROCESSAMENTO_7D" | "AUTUACAO_30D" | null;
}[] = [
  { rotulo: "Todas", trilha: null },
  { rotulo: "Envio · 24 h", trilha: "ENVIO_24H" },
  { rotulo: "Processamento · 7 dias", trilha: "PROCESSAMENTO_7D" },
  { rotulo: "Pagamento · 30 dias", trilha: "AUTUACAO_30D" },
];

/**
 * A fila da SENATRAN com o recorte, na concessão escolhida — o clique que abre exatamente o
 * que o número contou (`AC14`). `busca` leva a um trânsito só.
 */
export function enderecoDaFila(
  recorte: string,
  concessao: string,
  busca?: string,
): string {
  const p = new URLSearchParams({ recorte });
  if (concessao) p.set("concessao_id", concessao);
  if (busca) p.set("busca", busca);
  return `/senatran?${p.toString()}`;
}
